import { defaultSizesByBookingObjectType } from 'src/pages/AdministratorPage/consts';
import { BookingObject } from 'src/types';

import { AdminState } from './types';

export const emptyBookingObjects = new Map<string, BookingObject>();

export const initialState: AdminState = {
  loading: false,
  bookingObjects: emptyBookingObjects,
  placeLoading: false,
  backgroundLoading: false,
  sizesByBookingObjectType: defaultSizesByBookingObjectType,
  rotation: 0,
  townIsOpened: false,
  buildingIsOpened: false,
  floorIsOpened: false,
  permissionsAreOpened: false,
  bookingObjectIsOpened: false,
};
